module.exports = __webpack_public_path__ + "media/images/static/line/advisor-9ba2802ed96eda3dc853e94877a351de.png";